<script>
export default {
    name: 'BaseCalendarViewYear',
};
</script>

<script setup>
defineProps({
    date: {
        type:     Date,
        required: true,
    },
});
</script>

<template>
    <div class="flex flex-col">
        Year: Under Development
    </div>
</template>
